import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const LOGO_SRC =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_tfc-preview/artifacts/8wo6q5t4_64C5E782-E3B8-466C-A3C1-CAE785C8E0A5.jpg";

const fadeUp = {
  initial: { opacity: 0, y: 22 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-40px" },
};

const NAV = [
  { label: "Home", href: "#top" },
  { label: "Why We Exist", href: "#why-we-exist" },
  { label: "Who We Serve", href: "#who-we-serve" },
  { label: "Preview", href: "#preview" },
  { label: "Founding Members", href: "#founding-members" },
];

const linkClass =
  "font-body text-base text-[#B3B3B3] transition-colors duration-300 hover:text-[#26945D]";

function ColHeading({ children }) {
  return (
    <p className="font-body text-xs font-medium uppercase tracking-[0.28em] text-[#B3B3B3]/70">
      {children}
    </p>
  );
}

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative z-20 border-t border-[#2A2A2A] bg-[#0B0B0B] py-16 md:py-20"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        {/* Main grid */}
        <motion.div
          {...fadeUp}
          transition={{ duration: 0.8, ease: EASE }}
          className="grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1fr] lg:gap-14"
        >
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <img
              src={LOGO_SRC}
              alt="The Football Collective"
              className="h-16 w-auto mix-blend-screen"
              draggable="false"
            />
            <p className="mt-5 font-body text-base text-white/90">
              The Digital Home of Grassroots Football.
            </p>
            <p className="mt-3 max-w-[42ch] font-body text-sm font-light leading-relaxed text-[#B3B3B3]">
              Built for players, football communities, clubs and academies
              growing the game from the ground up.
            </p>
          </div>

          {/* Navigation */}
          <nav data-testid="footer-nav" className="flex flex-col">
            <ColHeading>Navigation</ColHeading>
            <div className="mt-6 flex flex-col gap-3.5">
              {NAV.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  data-testid={`footer-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className={linkClass}
                >
                  {item.label}
                </a>
              ))}
            </div>
          </nav>

          {/* Follow */}
          <div className="flex flex-col">
            <ColHeading>Follow</ColHeading>
            <div className="mt-6 flex flex-col gap-3.5">
              <a
                href="https://www.instagram.com/thefootball.collective?igsh=MTdqYjA4cDdubzdpcQ=="
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className={linkClass}
              >
                Instagram
              </a>
            </div>
          </div>

          {/* Contact */}
          <div className="flex flex-col">
            <ColHeading>Contact</ColHeading>
            <div className="mt-6 flex flex-col gap-3.5">
              <a
                href="mailto:thefootballcollective01@gmail.com"
                data-testid="footer-contact"
                className={`${linkClass} break-words`}
              >
                thefootballcollective01@gmail.com
              </a>
            </div>
          </div>
        </motion.div>

        {/* Divider + bottom row */}
        <div className="mt-14 md:mt-16 h-px w-full bg-[#2A2A2A]" />
        <div className="mt-6">
          <p className="font-body text-xs text-[#B3B3B3]/70">
            &copy; 2026 The Football Collective. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
